import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from '../layouts/RootLayout';
import { LoginPage } from '../features/auth/routes/LoginPage';
import { ResetPasswordPage } from '../features/auth/routes/ResetPasswordPage';
import PublicGuard from './guards/PublicGuard';
import AuthGuard from './guards/AuthGuard';
import { Files } from '../features/files/routes/Files';
import { Analysis } from '../features/analysis/routes/Analysis';
// import { RibReader } from '../features/tools/routes/RibReader';
// import { PhoneOperator } from '../features/tools/routes/PhoneOperator';
// import { ImageAnalysis } from '../features/tools/routes/ImageAnalysis';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: (
          <AuthGuard>
            <Files />
          </AuthGuard>
        ),
      },
      {
        path: 'files',
        element: (
          <AuthGuard>
            <Files />
          </AuthGuard>
        ),
      },
      {
        path: 'files/:id',
        element: (
          <AuthGuard>
            <Analysis />
          </AuthGuard>
        ),
      },
      // {
      //   path: 'tools/rib-reader',
      //   element: (
      //     <AuthGuard>
      //       <RibReader />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: 'tools/phone-operator',
      //   element: (
      //     <AuthGuard>
      //       <PhoneOperator />
      //     </AuthGuard>
      //   ),
      // },
      // {
      //   path: 'tools/image-analysis',
      //   element: (
      //     <AuthGuard>
      //       <ImageAnalysis />
      //     </AuthGuard>
      //   ),
      // },
      {
        path: 'login',
        element: (
          <PublicGuard>
            <LoginPage />
          </PublicGuard>
        ),
      },
      {
        path: 'reset-password',
        element: <ResetPasswordPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);
